module.exports = __webpack_public_path__ + "img/07.8198a035.jpg";